import { Button, Space, Tooltip } from "antd"
import { FC, memo } from "react"
import { IAudienceOption } from "../types/audience"

interface IButtonAudienceProps {
  options: IAudienceOption[]
  setIsModalOpen: (isModalOpen: boolean) => void
  value: string
}

const ButtonAudience: FC<IButtonAudienceProps> = memo(function ButtonAudience({
  options,
  setIsModalOpen,
  value,
}) {
  const tooltipText = options.find((option) => option.value === value)?.tooltip ?? value

  return (
    <Space>
      Audience:
      <Tooltip title={tooltipText}>
        <Button onClick={() => setIsModalOpen(true)}>{value}</Button>
      </Tooltip>
    </Space>
  )
})

export default ButtonAudience
